import React, { useEffect } from 'react';
import s from '../styles/CheckoutPage.module.css';
import { Link } from 'react-router-dom';

const CheckoutPage = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (!token) {
      alert('Токен оплаты отсутствует!');
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://yookassa.ru/checkout-widget/v1/checkout-widget.js';
    script.async = true;

    script.onload = () => {
      const checkout = new window.YooMoneyCheckoutWidget({
        confirmation_token: token,
        return_url: window.location.origin + '/success',
        error_callback: (error) => {
          console.error('Ошибка при загрузке виджета:', error);
        },
      });
      checkout.render('payment-form');
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div>
          <div className={s.back}>
              <Link to="/dashboard" className={s.btn_prev_2}>
                Отменить платеж.
              </Link>                 
          </div>

    <div style={styles.wrapper}>
      <div id="payment-form" style={styles.form}></div>
    </div>
    </div>
  );
};

const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
  },
  form: {
    width: '100%',
    maxWidth: 400,
  },
};

export default CheckoutPage;
